import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-caesar',
  templateUrl: './caesar.component.html',
  styleUrls: ['./caesar.component.css']
})
export class CaesarComponent extends CryptoView {

  _key: number;
  @Input() key:number;
  @Input() current: string;
  @Input() modus: string;
  @Input() direction: string;
  @Output() studentKey = new EventEmitter<number>();

  inputs: string[];
  hints: string[] = [];

  constructor(topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = new Array(26).fill(" ");
  }

  /** used by the html to highlight the correct element */
  currentIndex(): number {
    if (!this.current) {
      return -1;
    }
    if (this.modus == "highlight") {
      return this.current.charCodeAt(0) - 65;
    } else if (this.modus == "withoutKey") {
      return this.current.charCodeAt(0) - 65;
    } else {
      return -1;
    }
  }

  /** returns the current student mapping */
  getMapping() {
    return this.inputs.join("").slice(0, 26);
  }

  /** sets the mapping */
  setmapping(mapping: string) {
    this.inputs = mapping.slice(0, 26).split("");
  }

  /** resets the mapping */
  resetmapping() {
    this.setmapping("                               ")
  }

  /** sets the hints */
  setHints(hints: string[]) {
    this.hints = hints;
  }

  /** normalizes the key to be between 0 and 26 */
  normalizeKey() {
    if (this.key) {
      this.key = this.key % 26;
      if (this.key < 0) { this.key += 26; }
      this.studentKey.emit(this.key);
    }
  }

  /** fills the mapping with default */
  fillMapping() {
    for (let i in this.createArray(26)) {
      this.inputs[i] = String.fromCharCode((+i - this.key + 26) % 26 + 65);
    }
  }


}
